import { lazy, Suspense, useEffect, useState } from 'react';

const AnnouncementBar = lazy(() => import('@/components/AnnouncementBar'));
const SwitchWidget = lazy(() => import('@/components/SwitchWidget'));
const CookieBanner = lazy(() => import('@/components/CookieBanner'));

// Mounting the announcement can move the header. Start after activation,
// so it cannot move a menu button between pointerdown and click or steal
// keyboard focus before the current key has activated its control.
const INTERACTION_EVENTS = ['click', 'keyup', 'scroll'] as const;

/**
 * Chrome that is not needed for first paint: announcement bar, language
 * switcher, and cookie dialog. Load after the first user interaction so these
 * chunks do not compete with FCP/LCP or keep the network busy for TTI.
 */
const DeferredChrome = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let done = false;
    const start = () => {
      if (done) return;
      done = true;
      setReady(true);
    };

    INTERACTION_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, start, { capture: true, passive: true, once: true });
    });
    const timeoutId = window.setTimeout(start, 30000);

    return () => {
      INTERACTION_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, start, true);
      });
      window.clearTimeout(timeoutId);
    };
  }, []);

  if (!ready) return null;

  return (
    <Suspense fallback={null}>
      <AnnouncementBar />
      <SwitchWidget />
      <CookieBanner />
    </Suspense>
  );
};

export default DeferredChrome;
